import * as React from 'react';
import classNames from 'classnames';
import { Nav, NavItem } from 'reactstrap';
import { navigationConfigurationData, NavigationConfigurationItem, GlobalPrivateState, NavigationConfigurationModel, configurationPanels } from '../../../../api';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { RouterState } from 'connected-react-router';

import './ConfigurationNavigation.scss';
import { Icon } from '../../Images';

export interface ConfigurationNavigationProps {
  configuration: GlobalPrivateState['configuration'];
  configurationPanels: GlobalPrivateState['configurationPanels'];
  location: RouterState['location'];
  validated: GlobalPrivateState['validatedConfiguration'];
  dispatch: any;
}

export class ConfigurationNavigationPartial extends React.Component<ConfigurationNavigationProps> {
  public render() {
    const { location } = this.props;
    return (
      <div className="partial-configuration-navigation">
        <Nav className="navbar w-100 d-flex justify-content-end align-items-end p-0">
          {this.navigation && Object.keys(this.navigation).map((itemKey, index) => {
            const key = `configuration_navigation_${itemKey}_${index}`;
            const item = this.navigation && this.navigation[itemKey] as NavigationConfigurationItem;
            const isActive = item && (location.pathname === item.to) ? true : false;
            
            return item ? (
              <NavItem 
                key={key}
                className={classNames('flex-fill', {'is-active' : isActive})}
                active={isActive}
                disable={item.disabled.toString()}
              >
                <Link
                  to={item.to} 
                  title={item.title}
                  onClick={ev => this.handleClick(ev, item.disabled, isActive)}
                  className={classNames(
                    'd-flex',
                    'justify-content-center',
                    'align-items-center',
                    'w-100',
                    'text-center', {
                      'is-active' : isActive,
                      'disabled' : item.disabled
                    }
                  )}
                >
                  <Icon name={item.icon} size={'small'} />
                  <span>{item.name}</span>
                </Link>
              </NavItem>
            ) : null;
          })}
        </Nav>
      </div>
    );
  }

  private handleClick = (event: React.SyntheticEvent, disabled: boolean, isActive: boolean) => {
    if (disabled) {
      event.preventDefault();
    }

    if (isActive) {
      this.props.dispatch(configurationPanels.toggle());
    } else {
      this.props.dispatch(configurationPanels.show());
    }
  }

  private get navigation(): NavigationConfigurationModel | undefined {
    const {
      configuration,
      validated,
    } = this.props;
    const conf = configuration.result;
    if (!conf) { return; }
    const navigation = navigationConfigurationData(conf.id);
    Object.keys(navigation).map(key => navigation[key].disabled = validated.disabled[key]);
    return navigation;
  }
}

export const ConfigurationNavigation = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  configurationPanels: state.configurationPanels,
  validated: state.validatedConfiguration,
  location: state.router.location,
}))(ConfigurationNavigationPartial);

export default ConfigurationNavigation;


